<div class="control-section m-3" style="min-height: 649px">
  <div class="col-lg-9 content-wrapper" style="width: 100%">
    <p class="h3">Profile</p>
    <hr />
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="text-center">
          <img
            src="../../assets/images/user.png"
            class="rounded"
            alt="Emp Image"
            style="max-width: 250px"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12">
        <div class="row">
          <span class="fw-bold pb-2"> Employee Information </span>
          <hr />
        </div>
        <div class="row" *ngIf="employeeProfile">
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">Name: </span
            ><span>{{ employeeProfile?.fullName }}</span>
          </p>
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">Job Title: </span
            ><span>{{ employeeProfile.jobTitle }}</span>
          </p>
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">Email: </span
            ><span>{{ employeeProfile.email }}</span>
          </p>
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">Work Phone No: </span
            ><span>{{ employeeProfile.workPhone }}</span>
          </p>
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">HR Company: </span
            ><span class="text-wrap">{{ employeeProfile.hrCompanyName }}</span>
          </p>
          <p class="col-lg-6 col-md-6 col-sm-12">
            <span class="fw-bold">Pay Roll Company: </span
            ><span class="text-wrap">{{
              employeeProfile.payRollCompanyName
            }}</span>
          </p>
        </div>
        <br />
        <br />
      </div>
    </div>
    <div class="col-xs-12 mt-2">
      <button
        ejs-button
        id="btnCancel"
        class="e-info btn-bg float-end mx-1"
        (click)="GoBack()"
      >
        Go Back
      </button>
    </div>
  </div>
</div>
